<template>
  <v-container :style="{minHeight: $vuetify.breakpoint.smAndUp ? '352px' : ''}">
    <v-row v-if="displayState === 1 || displayState === 2" no-gutters>
      <v-col align="center"
             justify="center">
        <h4 class="archetype-title mb-6">{{ archetype.title }}</h4>

        <!-- class needed to position ground under the feet of the illustrations -->
        <fin-archetype-illustration :archetype="archetype"
                                    :animate="displayState !== 1"
                                    :height="$vuetify.breakpoint.xs ? 135 : 155"
                                    :hide-scene="displayState !== 2"
                                    :width="245"
                                    class="archetypeIllu"/>
        <p v-if="displayState === 2" class="archetype-short-description mt-3 mb-2">
          <span v-html="archetype.shortDescription"></span>
        </p>
      </v-col>
    </v-row>

    <v-row v-else-if="displayState === 3"
           align="center"
           no-gutters
           justify="center">
      <v-col align="center"
             class="col-illu"
             cols="12" sm="4"
             justify="center"
             style="background-position: top;"
             :style="{ backgroundImage: 'url(' + require('@/assets/archetypes/background/scene-' + archetype.id.toLowerCase() + '.svg') + ')'}"
      >
        <fin-archetype-illustration :archetype="archetype"
                                    :height="$vuetify.breakpoint.xs ? 155 : 225"
                                    animate
                                    hide-scene/>

      </v-col>
      <v-col align="start"
             cols="12" sm="8"
             justify="start"
      >
        <h4 class="archetype-title mb-2">{{ archetype.title }}</h4>
        <p class="archetype-long-description">
          <fin-lexicon-text :text="archetype.description" auto-solve/>
        </p>
      </v-col>
      <v-col align="start"
             cols="12" justify="start" offset-sm="4"
             sm="8"
      >
        <fin-archetype-props-matrix-tabs :archetype-classifications="archetypeClassifications"
                                         :classification-props="archetype.classification"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FinArchetypePropsMatrixTabs from '@/components/pages/onboarding/ArchetypePropsMatrixTabs/index'
import FinArchetypeIllustration from '@/components/pages/onboarding/ArchetypeIllustration/index'
import FinLexiconText from '@/components/common/lexicon/LexiconText/index'

/** Use the `ArchetypeItem` component for displaying a single item.
 * Based on the display state the component is displaying a different level of info. */
export default {
  name: 'finArchetypeItem',
  components: {FinLexiconText, FinArchetypeIllustration, FinArchetypePropsMatrixTabs},
  props: {
    /** the selected archetype object to display */
    archetype: {
      type: Object
    },
    /** a list of archetype classifications */
    archetypeClassifications: {
      type: Array,
      default: () => []
    },
    /** the current display state (1, 2, 3) */
    displayState: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/variables";

.archetype-title {
  font-family: $body-font-family;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
  /* additional styling */
  margin-bottom: 12px;
}

.archetype-short-description {
  font-family: $body-font-family;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: $fin-color-primary-dark;
  min-height: 72px;

  @media only screen and (max-width: 600px) {
    font-size: 15px;
  }
}

.archetype-long-description {
  font-family: $body-font-family;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}
</style>
